// Welche Nummer trägt ein Asset in Ordner- und Dateinamen (`3 - Titel`,
// `…_Asset3_…`)? Seit dem Audit 2026-09-24 (H4) die GLOBALE Position in der
// ungefilterten Asset-Liste des Projekts, die der Dienst pro Asset als
// `number` mitliefert. Grund: Im Multi-Lingual-Projekt kann eine Sprache
// einzelne Assets nicht haben („IT hat Asset 5 nicht“) — mit dem
// sprachgefilterten Index hieß dasselbe Asset dann in jeder Sprache anders,
// und /stream (das die ungefilterte Liste kennt) lief in 404.
//
// Custom-Assets stehen hinter allen vorgegebenen und haben kein `number`:
// dort gilt weiter der kombinierte Index + 1 (unverändert zu vorher).
// Standard-Projekte: `number` ist der Listenindex + 1 — byte-identisch.

/** 0-basierte Nummer für die Namensbauer (`FilenameContext.assetIdx`, `buildAssetFolderName`). */
export function assetGlobalIdx(
  asset: { number?: number } | null | undefined,
  combinedIdx: number,
): number {
  const n = asset?.number;
  if (typeof n === 'number' && Number.isInteger(n) && n >= 1) return n - 1;
  return combinedIdx;
}
